module.exports = __webpack_public_path__ + "img/message-1.1348ced5.png";